import { CanopyProvider } from '@bloomfieldrobotics/canopy';
import { Stack } from '@mui/material';
import { useCallback, useMemo } from 'react';
import { useTranslation } from '../../../services/translation/hooks/useTranslation';
import { BlockDropdown } from './BlockDropdown';
import { CustomerDropdown } from './CustomerDropdown';
import { RanchDropdown } from './RanchDropdown';
interface Props {
  customer: string;
  onCustomerChange: (value: string) => void;

  ranch: string;
  onRanchChange: (value: string) => void;

  block: string;
  onBlockChange: (value: string) => void;
}

const CustomerRanchBlockDropdowns: React.FC<Props> = ({
  customer = 'ALL_CUSTOMERS',
  onCustomerChange,
  ranch = 'ALL_RANCHES',
  onRanchChange,
  block = 'ALL_BLOCKS',
  onBlockChange,
}) => {
  const { t } = useTranslation();

  // Memoize extra options to avoid recreating them on every render
  const extraCustomerOptions = useMemo(
    () => [
      {
        label: t('All Customers'),
        value: 'ALL_CUSTOMERS',
      },
    ],
    [t]
  );

  const extraRanchOptions = useMemo(
    () => [
      {
        label: t('All Ranches'),
        value: 'ALL_RANCHES',
      },
    ],
    [t]
  );

  const extraBlockOptions = useMemo(
    () => [
      {
        label: t('All Blocks'),
        value: 'ALL_BLOCKS',
      },
    ],
    [t]
  );

  const handleCustomerValueChange = useCallback(
    (value: string) => {
      onCustomerChange(value);
      onRanchChange('');
      onBlockChange('');
    },
    [onCustomerChange, onRanchChange, onBlockChange]
  );

  const handleRanchValueChange = useCallback(
    (value: string) => {
      onRanchChange(value);
      onBlockChange('');
    },
    [onRanchChange, onBlockChange]
  );

  const handleBlockValueChange = useCallback(
    (value: string) => {
      onBlockChange(value);
    },
    [onBlockChange]
  );

  return (
    <CanopyProvider>
      <Stack spacing={2} direction={'row'}>
        <CustomerDropdown
          value={customer}
          onChange={handleCustomerValueChange}
          hideIfOneCustomer
          extraOptions={extraCustomerOptions}
        />
        <RanchDropdown
          customer={customer}
          value={ranch}
          onChange={handleRanchValueChange}
          extraOptions={extraRanchOptions}
          disabled={!customer || customer === 'ALL_CUSTOMERS'}
        />
        <BlockDropdown
          ranch={ranch}
          value={block}
          onChange={handleBlockValueChange}
          extraOptions={extraBlockOptions}
          disabled={!ranch || ranch === 'ALL_RANCHES'}
        />
      </Stack>
    </CanopyProvider>
  );
};

export default CustomerRanchBlockDropdowns;
